<template>
  <div>
    <time-line class="historial-line  p-2">
      <time-line-item
        v-for="item of visibleItems"
        :key="`History-${item.id}`"
        icon="fas fa-exchange-alt"
      >
        <template #date>
          <span class="color-secondary-6 font-12">Fecha:</span>
          <p class="color-black font-16">
            {{ $formatDate(item.createdDate, $templateDate.longDateWithHour) }}
          </p>
        </template>

        <div id="main-info" class="row  align-items-center">
          <div class="col-12 col-md-2 additional-evaluation ml-2 mt-1">
            <custom-balloon
              :background-color="item.status.color"
              dot
              :text="item.status?.name"
            />
          </div>

          <div class="col-12 col-md-3 mt-3 ">
            <div class="color-secondary-6 font-14">
              Usuario:
            </div>
            <div class="color-black font-16 font-weight-normal">
              {{ item.userFullName | capitalize }}
            </div>
          </div>
          <div v-if="item.comment" class="col-12 mt-3 bg-white rounded p-3">
            <div class="color-secondary-6 font-14">
              <i class="fas fa-info-circle mr-2 text-orange" />
              Comentario:
            </div>
            <div class="color-black font-16 font-weight-normal">
              {{ item.comment | empty }}
            </div>
          </div>
        </div>
      </time-line-item>
    </time-line>

    <div class="row">
      <div v-if="canShowMore" class="col-12 d-flex justify-content-center my-3">
        <action-button
          variant="outline-success custom-view-more actionButton rounded-pill"
          @click="loadMore"
        >
          Ver más
          <i class="ml-1 fas fa-chevron-down" />
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import { getBatchLog as getLog } from '@/modules/medicaid/medicaid-claim.api';
import CustomBalloon from 'custom-balloon';
import ActionButton from 'ActionButton';
export default {
  name: 'BatchHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomBalloon,
    ActionButton,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { history: [], visibleCount: 2 };
  },
  computed: {
    canShowMore() {
      return this.history.length > this.visibleCount;
    },
    visibleItems() {
      return this.history.slice(0, this.visibleCount);
    },
  },
  async mounted() {
    this.getLogHistory();
  },
  methods: {
    async getLogHistory() {
      const { data } = await getLog(this.item.id);
      this.history = data;
    },
    loadMore() {
      this.visibleCount += 1;
    },
  },
};
</script>
<style scoped>
::v-deep .icon-mr-0 {
  margin-right: 0 !important;
}
</style>
